import styled from 'styled-components';

export const StyledMultiSelectWrapper = styled.div`
  padding: ${({ theme }): string => theme.spacers!.spacer03} 0;
`;

export const StyledLabel = styled.div`
  font-family: InspireTWDC;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 21px;
  color: ${({ theme }): string => theme.admanColors!.gray.light.fg1[1]};
`;
